/** Snapshot do pipeline gravado em `room.settings.pipeline` para o dashboard. */
export interface RoomPipeline {
  segments: number[]
  stage_label: string
  now: string
  pending_hitl: boolean
  pending_adr_id?: string | null
  pending_adr_title?: string | null
  updated_at: string
}

export interface PauseAdr {
  adr_id?: string
  adr_title?: string
  block?: string
}

export interface PauseReview {
  perspective?: string
  feasibility?: string
  risks?: string[]
  recommendations?: string[]
}

export interface PipelinePause {
  adrs?: PauseAdr[]
  reviews?: PauseReview[]
}

export const PIPELINE_STAGES = ['Ideias', 'Event Storm', 'SDD', 'Diagramas', 'Protótipo'] as const

export function formatRelative(iso?: string | null): string {
  if (!iso) return ''
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''
  const diffSec = Math.round((Date.now() - date.getTime()) / 1000)
  if (diffSec < 60) return 'agora'
  const diffMin = Math.round(diffSec / 60)
  if (diffMin < 60) return `${diffMin} min`
  const diffHr = Math.round(diffMin / 60)
  if (diffHr < 24) return `${diffHr} h`
  const diffDay = Math.round(diffHr / 24)
  if (diffDay < 7) return `${diffDay} d`
  return date.toLocaleDateString('pt-BR')
}

const WS_COLORS = ['#6d3ae0', '#0d9488', '#c2417a', '#0284c7', '#a75a00']

export function workspaceColor(name: string): string {
  let hash = 0
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash)
  return WS_COLORS[Math.abs(hash) % WS_COLORS.length]
}

export function roleLabel(role?: string): string {
  if (role === 'owner') return 'Proprietário'
  if (role === 'admin') return 'Admin'
  if (role === 'viewer') return 'Leitor'
  return 'Editor'
}

/** Extrai alternativas `- **Nome**: detalhe` da seção Opções de um ADR. */
export function parseAdrOptions(block?: string): { name: string; detail: string }[] {
  if (!block) return []
  const idx = block.toLowerCase().search(/opç[õo]es/)
  const slice = idx >= 0 ? block.slice(idx) : ''
  if (!slice) return []
  const out: { name: string; detail: string }[] = []
  const re = /^\s*[-*]\s+\*\*(.+?)\*\*\s*[:\-–—]?\s*(.*)$/gm
  let match: RegExpExecArray | null
  while ((match = re.exec(slice))) {
    const name = match[1].trim()
    if (!name || /^status$/i.test(name)) continue
    out.push({ name, detail: match[2].trim() })
  }
  return out.slice(0, 4)
}
